import * as React from 'react';

export interface CardProps {
    type?: 'fill' | 'simple' ;
    header?: React.ReactNode

}

export interface CardState {
}

export default class Card extends React.Component<CardProps, CardState> {
  constructor(props: CardProps) {
    super(props);

    this.state = {
    }
  }

  public render() {
    return (
      <div className={`card ${this.props.type || 'fill'} `}>
           {this.props.header && <div className='card-header'>
                {this.props.header}
           </div>}
           <div className='card-content'>
                {this.props.children}
           </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/card.tsx